import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import { Grid } from '@material-ui/core';
import axios from 'axios';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';

import environment from '../../environment';

const useStyles = (theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  cssOutlinedInput: {
    '&$cssFocused $notchedOutline': {
      borderColor: '#8d8d8e',
    },
  },
  cssFocused: {},
  notchedOutline: {},
});

class NovaSenha extends Component {
  params = window.location.href.split('=');

  state = {
    valid: false,
    novasenha: '',
    repeatsenha: '',
    open: false,
    mensagem: '',
    tipomsg: '',
    token: this.params[1],
  };

  isValid = async () => {
    await axios
      .post(`${environment}/validarToken`, {
        password_reset_token: this.state.token,
      })
      .then((res) => {
        if (res.data.message === 'Ok') {
          this.setState({ valid: true });
        } else {
          this.setState({ valid: false });
        }
      })
      .catch((err) => {
        return false;
      });
  };

  handleSubmit = async () => {
    await this.isValid();
    if (this.state.novasenha !== this.state.repeatsenha) {
      this.setState({ tipomsg: 'warning' });
      this.setState({ open: true });
      this.setState({ mensagem: 'As senhas digitadas não são iguais' });
    } else if (this.state.novasenha.length < 6) {
      this.setState({ tipomsg: 'warning' });
      this.setState({ open: true });
      this.setState({ mensagem: 'A senha deve ter no minímo 6 catacteres' });
    } else if (this.state.valid) {
      axios
        .post(`${environment}/resetarSenha`, {
          password: this.state.novasenha,
          password_reset_token: this.state.token,
        })
        .then((res) => {
          this.setState({ tipomsg: 'sucess' });
          this.setState({ open: true });
          this.setState({ mensagem: 'Senha redefinida com Sucesso!' });
          this.props.history.push('/');
        })
        .catch((err) => {
          this.setState({ tipomsg: 'error' });
          this.setState({ open: true });
          this.setState({ mensagem: 'Erro ao redefinir senha!' });
        });
    } else {
      this.setState({ tipomsg: 'error' });
      this.setState({ open: true });
      this.setState({
        mensagem: 'Token inspirado, Gere um novo para redefinir a senha',
      });
    }
  };

  clickAlert = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;

    return (
      <>
        <Collapse in={this.state.open}>
          <Alert severity={this.state.tipomsg} onClick={this.clickAlert}>
            {this.state.mensagem}
          </Alert>
        </Collapse>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          style={{ minHeight: '100vh', backgroundColor: XMEI_PRIMARY_COLOR }}
        >
          <div style={{ width: 250, marginTop: '7%', marginBottom: 30 }}>
            <img
              src={`${process.env.PUBLIC_URL}/logo-white.png`}
              alt="Xmei Logo"
              style={{
                display: 'block',
                width: '100%',
                height: 'auto',
              }}
            />
          </div>
          <Container
            component="main"
            maxWidth="xs"
            style={{ backgroundColor: 'white', padding: 25, borderRadius: 5 }}
          >
            <CssBaseline />
            <div className={classes.paper}>
              <Typography
                component="h1"
                variant="h5"
                style={{ textAlign: 'center', marginBottom: 10 }}
              >
                Digite sua nova senha
              </Typography>
              <form className={classes.form} noValidate>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  label="Digite sua senha"
                  type="password"
                  autoFocus
                  onChange={(novasenha) => {
                    this.setState({ novasenha: novasenha.target.value });
                  }}
                  InputProps={{
                    classes: {
                      root: classes.cssOutlinedInput,
                      focused: classes.cssFocused,
                      notchedOutline: classes.notchedOutline,
                    },
                  }}
                  InputLabelProps={{
                    style: {
                      color: '#9e9e9e',
                    },
                  }}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  type="password"
                  label="Confirme sua senha"
                  onChange={(repeatsenha) =>
                    this.setState({ repeatsenha: repeatsenha.target.value })
                  }
                  InputProps={{
                    classes: {
                      root: classes.cssOutlinedInput,
                      focused: classes.cssFocused,
                      notchedOutline: classes.notchedOutline,
                    },
                  }}
                  InputLabelProps={{
                    style: {
                      color: '#9e9e9e',
                    },
                  }}
                />
                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  className={classes.submit}
                  style={{
                    backgroundColor: XMEI_PRIMARY_COLOR,
                    color: '#FFF',
                    fontWeight: 'bold',
                    height: '45px',
                    marginTop: '15px',
                  }}
                  onClick={this.handleSubmit}
                >
                  Salvar
                </Button>
              </form>
            </div>
          </Container>
        </Grid>
      </>
    );
  }
}

export default withStyles(useStyles)(NovaSenha);
